import { InjectionToken } from '@angular/core';

import { IAuthConfig } from '../models/auth-config';

export const AUTH_CONFIG = new InjectionToken<IAuthConfig>('@sona/angular-auth-domain.auth-config');
